export function formatGold(amount: number): string {
  return `${amount.toLocaleString()} Gold`;
}

/** Convert raw internal momentum value to player-facing display value. */
export function displayMomentum(raw: number): number {
  return raw / 100;
}
